"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const Checked = () => /*#__PURE__*/_react.default.createElement("svg", {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/_react.default.createElement("circle", {
  opacity: "0.403706",
  cx: "12",
  cy: "12",
  r: "10",
  fill: "#38D430"
}), /*#__PURE__*/_react.default.createElement("path", {
  d: "M8.5 11.7917L11.2222 15L15.5 9.5",
  stroke: "#38D430",
  strokeWidth: "2",
  strokeLinecap: "round"
}));

var _default = Checked;
exports.default = _default;